import React from 'react';
import PropTypes from 'prop-types';
import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import IconButton from 'material-ui/IconButton';
import ContentClear from 'material-ui/svg-icons/content/clear';

const listItemStyle = {
  border: '1px solid #dbdbdb',
  color: '#75bae7',
  margin: 5,
};

const FilesToUploadList = ({ acceptedFiles, onDiscardFile }) => (
  <List className="dragDrop__list">
    {
      acceptedFiles.map(file => (
        <ListItem key={ file.name } style={ listItemStyle }>
          <div className="files-upload-list__elements">
            <div className="files-upload-list__label">{ file.name }</div>
            <IconButton className="files-upload-list__button" onClick={ () => onDiscardFile(file) }>
              <ContentClear />
            </IconButton>
          </div>
        </ListItem>
      ))
    }
  </List>
);

FilesToUploadList.propTypes = {
  acceptedFiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDiscardFile: PropTypes.func.isRequired
};

export default FilesToUploadList;



// WEBPACK FOOTER //
// ./src/shared/components/fileDrop/c/filesToUploadList/FilesToUploadList.js